import { useEffect, useRef, useState } from "react";

export function useDebounced(value, ms = 400) {
  const [out, setOut] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setOut(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return out;
}

export function useDebouncedCallback(fn, ms = 400) {
  const ref = useRef(fn);
  ref.current = fn;
  const tref = useRef(null);
  return (...args) => {
    if (tref.current) clearTimeout(tref.current);
    tref.current = setTimeout(() => ref.current(...args), ms);
  };
}
